import { Button, Stack, TextField } from "@mui/material";
import { useAuth } from "../../providers/AuthenticationProvider";
import { useState } from "react";
import { useNetwork } from "../../providers/NetworkProvider";
import { useSnackbar } from "../../providers/SnackbarProvider";

const AssociateTraderToAffiliate = () => {
	const [affiliateUid, setAffiliateUid] = useState<string>("");
	const [traderUid, setTraderUid] = useState<string>("");
	const { makePost } = useNetwork();
	const { openLoadingSnackbar, closeLoadingSnackbar, openSnackbar } =
		useSnackbar();
	const { user } = useAuth();

	const handleAffiliateUidChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setAffiliateUid(event.target.value);
	};
	const handleTraderUidChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		setTraderUid(event.target.value);
	};
	const handleAssociateTraderAffilaite = async () => {
		if (user == null) return;
		openLoadingSnackbar();
		try {
			const tokenId = await user.getIdToken();
			const res = await makePost(
				"admin/associsateAffiliateToAffiliateMaster",
				{
					affiliateUid: affiliateUid,
					affiliateMasterUid: traderUid,
				},
				tokenId
			);

			console.log(res);
			if (res.status === 200) {
				openSnackbar(
					"Success",
					"The user has been made a trader",
					"success"
				);
			} else {
				throw new Error("something went wrong");
			}
		} catch (err) {
			const error = err as Error;

			openSnackbar("Error", error.message, "error");
			console.error(err);
		}
		closeLoadingSnackbar();
	};
	return (
		<>
			<Stack
				spacing={2}
				sx={{ maxWidth: 440, margin: "auto", display: "block" }}
			>
				<h3>Associate Afflliate - Trader</h3>
				<TextField
					id="affiliateUid"
					label="affiliateUid"
					color="primary"
					fullWidth
					value={affiliateUid}
					onChange={handleAffiliateUidChange}
				/>
				<TextField
					id="traderUid"
					label="traderUid"
					color="primary"
					fullWidth
					value={traderUid}
					onChange={handleTraderUidChange}
				/>
				<Button
					variant="contained"
					color="secondary"
					onClick={handleAssociateTraderAffilaite}
					size="large"
					fullWidth
					sx={{
						height: "55px",
						textTransform: "none",
						fontFamily: "Work Sans !important",
					}}
				>
					Make Affiliate
				</Button>
			</Stack>
		</>
	);
};

export default AssociateTraderToAffiliate;
